<script lang="ts">
import {defineComponent, onMounted} from "vue";
import Navbar from "@/components/Navbar.vue";
import {GetCalendarDataForYear} from "@/data/calendarData";
import {store} from "@/store";
export default defineComponent({
  components: {Navbar},
  setup() {
    onMounted(() => {
      const currentYear = new Date().getFullYear().toString();
      const upcomingYear = (new Date().getFullYear() + 1).toString();
      
      // Fetch the calendar data for the current year and upcoming year
      GetCalendarDataForYear(currentYear)
          .then((calendarData) => {
            store.commit('PUSH_CALENDARDATA', calendarData);
          })
          .catch((error) => {
            console.error('Error fetching calendarData:', error);
          });

      GetCalendarDataForYear(upcomingYear)
          .then((calendarData) => {
            store.commit('PUSH_CALENDARDATA', calendarData);
          })
          .catch((error) => {
            console.error('Error fetching calendarData:', error);
          });
    });
  }
});
</script>

<template>
  <v-app>
    <Navbar/>
    <v-main class="main">
       <router-view></router-view>
    </v-main>
  </v-app>
</template>

<style >
html {
  -webkit-text-size-adjust: none; /* Safari und iOS */
  -moz-text-size-adjust: none;    /* Firefox */
  -ms-text-size-adjust: none;     /* Internet Explorer */
  text-size-adjust: none;         /* Standard */
}

body {
  font-family: 'Geometria Narrow Regular', 'Geometria Narrow Medium', 'Geometria Narrow Bold', sans-serif;
}
.v-navigation-drawer {
  z-index: 999999999 !important;
}

.main {
  /*padding-top: 1px !important;*/
  padding-bottom: 50px !important;
}
/*
@media (prefers-color-scheme: dark) {
  body {
    background-color: #121212 !important;
    color: white !important;
  }
}*/

</style>


